interface Link {
  link: string;
  title: string;
}

export interface EmptyListInfoProps {
  className: string;
  title: string;
  helpImage: string;
  helpTitle: string;
  helpSubtitle: string;
  helpLinks: Link[];
}

export const EmptyListInfo = ({
  title,
  className,
  helpSubtitle,
  helpTitle,
  helpLinks,
  helpImage,
}: EmptyListInfoProps) => (
  <div className={className}>
    <img alt={title} className="img-fluid mb-4 shadow" src={helpImage} />
    <h5 className="fs-6">{helpTitle}</h5>
    <p className="mt-2">
      <small>{helpSubtitle}</small>
    </p>
    <p className="fs-6">
      {(helpLinks || []).map((item, idx) => (
        <a key={idx} className="d-inline-block fs-6 mb-2" href={item.link} target="_blank">
          {item.title}
        </a>
      ))}
    </p>
  </div>
);
